import {makeStyles} from '@material-ui/core/styles'
import {Placemark} from '@yandex-taxi/react-ymaps'
import {Props as PlacemarkProps} from '@yandex-taxi/react-ymaps/build/main/components/placemark'
import React from 'react'

import {VehicleIcon} from '../../icons'

const useClasses = makeStyles({
  root: {
    marginTop: -16,
    marginLeft: -16,
  },
})

const VehiclePlacemark: React.FC<PlacemarkProps> = props => {
  const classes = useClasses()

  return (
    <Placemark {...props}>
      <VehicleIcon className={classes.root} />
    </Placemark>
  )
}

export default VehiclePlacemark
